<script>
import { Line, mixins } from "vue-chartjs";
//import zoom from "chartjs-plugin-zoom";

export default {
    extends: [Line],
    mixins: [Line, mixins.reactiveData],
    //====================================================================
    props: {
        //chartOptions: {},
        chartDataChild: {},
        yRange: { min: Number, max: Number },
    },
    //====================================================================
    data() {
        return {
            //ymax: "15",
        };
    },
    //====================================================================
    created: function () {
        //this.buildOption();
    },
    //====================================================================
    mounted() {
        //this.addPlugin(zoom);
        this.renderChart(this.chartDataChild, this.chartOptions);
    },
    //====================================================================
    watch: {
        chartDataChild: async function () {
            await this.buildOption();
            await this.renderChart(this.chartDataChild, this.chartOptions);
        },
    },
    //====================================================================
    methods: {
        buildOption() {
            this.chartOptions = {
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        filter: function (items) {
                            if (["水位", "フロート"].includes(items.text)) return false;
                            return false;
                        },
                    },
                },
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            distribution: "linear", // use 'linear'(default) or 'series'
                            time: { displayFormats: { hour: "D日H時", day: "D日H時", month: "D日H時" } },
                            //ticks: { minRotation: 10, maxRotation: 40, maxTicksLimit: 9 },
                            ticks: { minRotation: 0, maxRotation: 0, maxTicksLimit: 4 },
                            gridLines: { drawOnChartArea: true },
                        },
                    ],
                    yAxes: [
                        {
                            id: "axis-depth",
                            display: true,
                            position: "left",
                            scaleLabel: { display: false, labelString: "水位(m)", fontColor: "navy" },
                            ticks: {
                                fontColor: "navy",
                                min: Number(this.yRange.min) ? Number(this.yRange.min) : 0,
                                max: Number(this.yRange.max) ? Number(this.yRange.max) : 10,
                            },
                        },
                        {
                            display: false,
                            id: "axis-float",
                            ticks: { min: 0, max: 1 },
                        },
                    ],
                },
                tooltips: {
                    enabled: true,
                    //--------------------------------------------------
                    // callbacks: {
                    //     label: function (tooltipItem, data) {
                    //         const datasetIndex = tooltipItem.datasetIndex;
                    //         const datasetLabel = data.datasets[datasetIndex].label || "";
                    //         const value = tooltipItem.yLabel;
                    //         if (datasetLabel == "水位") {
                    //             return datasetLabel + ": " + value + " (m)";
                    //         } else {
                    //             return datasetLabel;
                    //         }
                    //     },
                    // },
                    //--------------------------------------------------
                },
                elements: {
                    line: { tension: 0.2 }, // line: { tension: 0.4 },
                    point: { radius: 1, hitRadius: 10, hoverRadius: 1, hoverBorderWidth: 3 },
                },
                animation: false,
            };
        },
    },
    //====================================================================
};
</script>
